import angular from 'angular';

export default angular.module('cms.loader.manager', []).factory('LoaderManager', function() {

    let loaders = {};

    this.getActive = function(key) {
        return loaders[key];
    };

    this.setActive = function(key, active) {
        loaders[key] = (typeof active === 'undefined') ? true : active;
    };

    return this;

}).name;


// WEBPACK FOOTER //
// ./src/cmsCore/Loader/LoaderManager.js